// extracted by mini-css-extract-plugin
export default {"infoIcon":"ActivityDetails__infoIcon___ONOlb","input":"ActivityDetails__input___IrJ7s","hiddenInput":"ActivityDetails__hiddenInput___bYf63"};